import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AccountInfo } from '../../models/accountInfo.model';
import { SetTitle } from '../../ngxs/action/account.action';
import { AccountState } from '../../ngxs/state/account.state';
import { AuthService } from './../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  @Select(AccountState.account)
  account$: Observable<AccountInfo>;

  accountInfo: AccountInfo = new AccountInfo();

  isAdministrator = false;

  constructor(
    private translateService: TranslateService,
    private store: Store,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x) {
          this.accountInfo.email = x.email;
          this.accountInfo.firstName = x.firstName;
          this.accountInfo.lastName = x.lastName;
          if (x.userType.toString() === 'Administrator') {
            this.isAdministrator = true;
          }
        }
      })
    );
  }

  changeTitle(title: string) {
    this.store.dispatch(new SetTitle(title));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
